import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import { API_KEYS, FMP_API_ENDPOINTS } from "../util/Constants";
import axios from "axios";

const PROFILE_FONT = "'Lato', 'Helvetica Neue', Arial, sans-serif";
const CARD_HEADER_BG = "#f5f2ed";
const CARD_HEADER_TEXT = "#1a2744";
const BORDER_LIGHT = "#e8eef6";

export default function StockGrade(props) {
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    const fetchGrade = async () => {
      try {
        const symbol = props.symbol;
        if (!symbol) {
          return;
        }

        const url = `${FMP_API_ENDPOINTS.STOCK_GRADE(props.symbol)}&${
          API_KEYS.FMP_API_KEY
        }`;
        const response = await axios.get(url);

        if (Array.isArray(response.data)) {
          setGrades(response.data);
        } else {
          setGrades([]);
        }
      } catch (error) {
        console.error("Error fetching grade data:", error);
        setGrades([]);
      }
    };

    fetchGrade();
  }, [props.symbol]);

  return (
    <TableContainer component={Paper} elevation={0} sx={{ fontFamily: PROFILE_FONT }}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={3}
              sx={{
                fontFamily: PROFILE_FONT,
                backgroundColor: CARD_HEADER_BG,
                color: CARD_HEADER_TEXT,
                fontWeight: 700,
                fontSize: "1rem",
                py: 1.25,
                px: 2,
                borderBottom: `1px solid ${BORDER_LIGHT}`,
              }}
            >
              Recent Upgrades/Downgrades
            </TableCell>
          </TableRow>
          {grades.length > 0 ? (
            grades
              .filter((grade) => grade != null)
              .slice(0, 10)
              .map((grade, index) => (
              <TableRow
                key={index}
              sx={{
                "&:hover": {
                  backgroundColor: CARD_HEADER_BG,
                },
              }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontFamily: PROFILE_FONT,
                    width: "20%",
                    whiteSpace: "nowrap",
                    fontSize: "0.875rem",
                  }}
                >
                  {grade && grade.date
                    ? new Date(grade.date).toLocaleDateString()
                    : "N/A"}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: PROFILE_FONT,
                    width: "30%",
                    fontSize: "0.875rem",
                  }}
                  align="right"
                >
                  {grade.gradingCompany || "N/A"}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: PROFILE_FONT,
                    width: "50%",
                    fontSize: "0.875rem",
                    color:
                      grade.action === "upgrade"
                        ? "success.main"
                        : grade.action === "downgrade"
                        ? "error.main"
                        : "text.primary",
                  }}
                  align="right"
                >
                  {grade.previousGrade} → {grade.newGrade}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Typography variant="body2" color="text.secondary">
                  No grade changes available
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
